<template>
    <v-layout row justify-center>
        <v-dialog v-model="isOpen" persistent max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">Новое письмо</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Кому" autofocus type="email" v-model="to" required></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field label="Тема" v-model="subject"></v-text-field>
                            </v-flex>
                            <v-flex xs12>

                                <interface-document v-if="isOpen" v-model="content" :options="{menubar: false}"></interface-document>

                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="sendLetter(true)">Отправить</v-btn>
                    <v-btn color="blue darken-1" flat @click.native="sendLetter(false)">Отмена</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>
    import InterfaceDocument from '@/components/interface/document'

    export default {
        props: {
            isOpen: {
                type: Boolean,
                required: true
            }
        },
        components: {
            InterfaceDocument
        },
        data() {
            return {
                subject: '',
                content: '',
                to: ''
            }
        },
        methods: {
            sendLetter(shouldSend) {
                this.$emit('send-mail', {
                    shouldSend,
                    subject: this.subject,
                    content: this.content,
                    to: this.to
                })
                this.subject = this.content = this.to = null
            }
        }
    }
</script>
<style>
    textarea {
        resize: none;
    }
</style>


